import React from "react";
import { useEffect } from "react";
import DummyDashboard from "../../portals/customer/pages/dashboard/DummyDashboard";
import NewSetPasswordCreationModal from "./NewSetPasswordCreationModal";
import { useSelector } from "react-redux";
import { storeSelector } from "../../redux/slices/storeSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { isClientPreview } from "../../utils/clientPreview";
import CreateAccount from "../../components/welcome/CreateAccount";

const DEMO_DETAILS = { shop_details: { shop_owner: "Robin", owner_email: "owner@your-store.com", shop_name: "Your store" } };

export default function SetPasswordForShopifyStoreOwner() {
  const { shopifyAppUserDetails, shopifyAppStore } = useSelector(storeSelector);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (shopifyAppStore?.shop_details || shopifyAppUserDetails?.shop_details) {
      handleOpen();
    }
  }, [shopifyAppStore?.shop_details, shopifyAppUserDetails?.shop_details]);

  const navigate = useNavigate();
  const { search } = useLocation();
  const demo = isClientPreview() && new URLSearchParams(search).has("demo");
  const details = shopifyAppStore?.shop_details ? shopifyAppStore : shopifyAppUserDetails;

  // Already signed in: go straight to the dashboard, like the old password modal did.
  useEffect(() => {
    const role = JSON.parse(localStorage.getItem("loggedUser"))?.user?.role;
    if (!demo && isClientPreview() && role) navigate(role === "admin" ? "/admin/dashboard" : "/customer/dashboard");
  }, [demo, navigate]);

  if (isClientPreview()) {
    const shown = demo ? DEMO_DETAILS : details;
    return (
      <>
        {shown?.shop_details && <CreateAccount userDetails={shown} demo={demo} />}
        {/* Same dusk background as the sign in page, instead of the old sample dashboard. */}
        <div
          aria-hidden="true"
          style={{
            position: "fixed",
            inset: 0,
            background: "linear-gradient(180deg, #160a3a 0%, #2c1470 26%, #6c4fd0 52%, #d9cdf7 74%, #f4f0fc 100%)",
          }}
        />
      </>
    );
  }

  return (
    <>
      <div style={{ visibility: "hidden" }}>
        <NewSetPasswordCreationModal
          handleOpen={handleOpen}
          handleClose={handleClose}
          open={open}
          setOpen={setOpen}
          userDetails={
            shopifyAppStore?.shop_details
              ? shopifyAppStore
              : shopifyAppUserDetails
          }
        />
      </div>
      <DummyDashboard
        storeOwner={
          shopifyAppUserDetails?.shop_details?.shop_owner ||
          shopifyAppStore?.shop_details?.shop_owner
        }
        ownerEmail={
          shopifyAppUserDetails?.shop_details?.owner_email ||
          shopifyAppStore?.shop_details?.owner_email
        }
        storeName={
          shopifyAppUserDetails?.shop_details?.shop_name ||
          shopifyAppStore?.shop_details?.shop_name
        }
      />
    </>
  );
}
